"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    BaseBytecloudDomainIDService: ()=>BaseBytecloudDomainIDService
});
const core_lib_namespaceObject = require("@bytecloud/core-lib");
const external_domain_id_config_js_namespaceObject = require("./domain-id.config.js");
const external_tool_js_namespaceObject = require("../tool.js");
const external_init_config_js_namespaceObject = require("../init-config.js");
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
class BaseBytecloudDomainIDService extends core_lib_namespaceObject.BaseDomainIDService {
    constructor(props){
        const options = {
            url: props.url,
            hostnameMap: {},
            regionEnvMap: external_domain_id_config_js_namespaceObject.regionEnvMap,
            triggerException (position, message) {
                throw new external_tool_js_namespaceObject.CommonLibError(position, message);
            },
            calcDomainID (urlObj) {
                var _props_calcDomainID;
                if ('undefined' != typeof self && self.bytecloudDomainID) return self.bytecloudDomainID;
                const { hostname } = urlObj;
                const hostnameMap = _object_spread({}, props.hostnameMap, external_domain_id_config_js_namespaceObject.cloudHostnameMap);
                if (hostnameMap[hostname]) return hostnameMap[hostname];
                const ipRegex = /^\d{0,3}\.\d{0,3}\.\d{0,3}\.\d{0,3}$/;
                if (ipRegex.test(hostname)) {
                    console.info("[INFO] \u901A\u8FC7 ip \u8BBF\u95EE\uFF0CdomainID \u4E3A local");
                    return 'local';
                }
                const ideRegex = /\.ide(-proxy-cn|-proxy-us|-proxy-boe|-proxy-boei18n|boe-proxy-boe|-boe)?\.byted\.org$/;
                if (ideRegex.test(hostname)) {
                    console.info("[INFO] \u901A\u8FC7 cloudIDE \u57DF\u540D\u8BBF\u95EE\uFF0CdomainID \u4E3A local");
                    return 'local';
                }
                const aiSandboxRegex = /\.aisandbox\.(bytedance|tiktok-row|byteintl)\.net$/;
                if (aiSandboxRegex.test(hostname)) {
                    console.info("[INFO] \u901A\u8FC7 AI Sandbox \u57DF\u540D\u8BBF\u95EE\uFF0CdomainID \u4E3A local");
                    return 'local';
                }
                try {
                    const result = window.sessionStorage.getItem((0, external_init_config_js_namespaceObject.getSessionStorageKey)('domainID'));
                    if (result) return result;
                } catch (error) {}
                return (null == (_props_calcDomainID = props.calcDomainID) ? void 0 : _props_calcDomainID.call(props, urlObj)) || void 0;
            }
        };
        super(options);
    }
}
exports.BaseBytecloudDomainIDService = __webpack_exports__.BaseBytecloudDomainIDService;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "BaseBytecloudDomainIDService"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
